import React from 'react';
import { MapPin } from 'lucide-react';
import AddressFields from './shared/AddressFields';

// Contact profile → Overview address card (ticket 188 row 4).
//
// The contact model stores {line1, line2, city, state, zip, country}; the shared
// AddressFields block speaks {street, unit, ...}, so this maps between them.
// The GoHighLevel sync does not carry an address either way, so the fields are
// editable on every contact, GHL-managed ones included, and saved in BFY only.
const PARTS = ['line1', 'line2', 'city', 'state', 'zip'];

const toForm = (a) => ({
  street: a?.line1 || '', unit: a?.line2 || '', city: a?.city || '', state: a?.state || '', zip: a?.zip || '',
});

const fromForm = (f, prev) => {
  const next = { line1: f.street, line2: f.unit, city: f.city, state: f.state, zip: f.zip };
  if (PARTS.every((k) => !(next[k] || '').trim())) return null;
  return { ...next, country: prev?.country || 'US' };
};

// Trimmed copy for saving, or null when every part is blank.
export function cleanAddress(a) {
  if (!a) return null;
  const out = {};
  PARTS.forEach((k) => { const v = (a[k] || '').trim(); if (v) out[k] = v; });
  return Object.keys(out).length ? { ...out, country: a.country || 'US' } : null;
}

export default function ContactAddressCard({ mailing, property, onChange, ghl = false }) {
  return (
    <div className="bg-white rounded-2xl border border-slate-100 shadow-sm p-5" data-testid="contact-address-card">
      <h3 className="text-sm font-medium text-slate-500 mb-4 flex items-center gap-2">
        <MapPin size={14} /> Addresses
      </h3>
      <div className="space-y-4">
        <AddressFields
          label="Mailing address"
          testIdPrefix="contact-mailing"
          value={toForm(mailing)}
          onChange={(f) => onChange('mailing_address', fromForm(f, mailing))}
        />
        <AddressFields
          label="Current property address"
          testIdPrefix="contact-property"
          value={toForm(property)}
          onChange={(f) => onChange('current_property_address', fromForm(f, property))}
        />
      </div>
      {ghl && (
        <p className="text-[11px] text-slate-400 mt-3" data-testid="contact-address-ghl-note">
          Saved in BFY only. Addresses are not synced with GoHighLevel.
        </p>
      )}
    </div>
  );
}
